import { useNavigate } from "react-router-dom";
import { Button } from "@nextui-org/react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4 p-2 md:p-6">
      <div className="flex h-[700px] flex-col items-center justify-center text-white">
        <div className="text-5xl">404 Not Found</div>
        <div>Sorry, the page you are looking for does not exist.</div>

        <div className="pt-5">
          <Button
            className="admin-common-button-gradient font-ubuntu w-full rounded-md px-10 text-base font-normal"
            onClick={() => navigate("/")}
          >
            Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
